import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import RegisterImage from "../../../images/register-left.png"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { doClearResetPassword, doRequestResetPassword } from "../../../actions/resetPasswordAction"
import AuthInterface from '../../../interface/reducers/auth'
import { Alert, Form } from "reactstrap"
import { printErrorNew } from '../../../utils/Helpers'


interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

interface UserData {
  status_code: number;
  email: string;
}

type ForgotPassword = {
  history: History;
  load(): any;
  dataAuth: AuthInterface;
  submit(args: Object): any;
}

const PageForgotPasswordV3: FC<ForgotPassword> = ({ history, load, submit, dataAuth, dataReset }) => {

  const [email, setEmail] = useState("")
  const [error, setError] = useState([])
  const [isDisabled, setIsDisabled] = useState(true)

  useEffect(() => {
    if(email){
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [email])

  useEffect(() => {
    const { userdata } = dataAuth;
    if (userdata.status_code === 200) {
      setEmail(userdata.email)
    }
    load()
  }, [])

  interface Value {
    value: string;
  }
  interface Event {
    target: Value;
  }

  function onChangeInputEmail(e: Event) {
    const emailText = (e.target.value).replace(/\s/g,''); //HANDLE TRIM WHITE SPACE
    
    setEmail(emailText)
  }

  function goToLoginPage() {
    history.push("/login")
  }

  function goToRegisterPage() {
    history.push("/register")
  }

  function submitForgotPassword(e: any) {
    e.preventDefault()

    submit({ email })
    .then(({value}) => {
      if(value.status_code == 200){
        history.push('/forgot-password/success')
      }
    })
    .catch(e => null)
  }

  return (
    <div className="page-forgot-password">
      <div className="left-side">
        <KickImage src={RegisterImage} alt="registration image" />
        <h4>What are you waiting for?</h4>
        <h5>Immerse yourself in the latest trend in fashion</h5>
      </div>
      <div className="right-side">
        <div className="forgot-title">
          <p>Forgot Password</p>
        </div>
        <div className="forgot-desc">
          <h4>Please enter your email address below. you will receive a link to reset your password.</h4>
        </div>
        <div className="forgot-form">
          <Form onSubmit={isDisabled ? null : (e) => submitForgotPassword(e)}>
            <input value={email} onChange={onChangeInputEmail} placeholder="Enter Email" type="email" />
            {
              dataReset?.error && (
                <p style={{color: "red", fontSize: "14px", paddingBottom: "16px", marginBottom: "0px"}}>{printErrorNew(dataReset?.error)}</p>
              )
            }
            <input onClick={isDisabled ? null : (e) => submitForgotPassword(e)} style={{ color: isDisabled ? "#939393" : "#fff", backgroundColor: isDisabled ? "#ebebeb" : "#159953", borderRadius: window.screen.availWidth < 480 ? "100000px" : "5px", padding: "10px", fontSize: "14px" }} type="submit" value="Confirm" />
          </Form>
        </div>
        
        {!dataAuth.isLogged && 
          <div className="forgot-navigation">
            <h4>Back to <span onClick={() => goToLoginPage()}>Login</span> or <span onClick={() => goToRegisterPage()}>Register</span></h4>
          </div>
        }
      </div>
    </div>
  )
}

interface State {
  dataAuth: Object;
  dataResetPassword: Object;
}

const mapStateToProps = (state: State) => ({
  dataAuth: state.dataAuth,
  dataReset: state.dataResetPassword
})

const mapDispatchToProps = (dispatch: any) => ({
  load: () => dispatch(doClearResetPassword()),
  submit: (payload: Object) => dispatch(doRequestResetPassword(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageForgotPasswordV3))